import classNames from 'classnames'

import { AIButtonIconGradientSvgPlacement } from '../AIButton.constants'
import { useAIButtonIconGradientId } from '../AIButton.hooks'
import { getAIButtonIconGradientStyleVars } from '../AIButton.utils'
import { AIButtonIconGradientDef } from '../AIButtonIconGradientDef'

import * as styles from './AIButton.module.css'

function AIButton({
  Button,
  className,
  gradientIdPrefix,
  gradientPlacement = AIButtonIconGradientSvgPlacement.Offscreen,
  isLoading,
  style,
  ...restProps
}) {
  const gradientId = useAIButtonIconGradientId(gradientIdPrefix)

  return (
    <>
      <AIButtonIconGradientDef
        gradientId={gradientId}
        placement={gradientPlacement}
      />
      <Button
        {...restProps}
        className={classNames(className, {
          [styles.loading]: isLoading && gradientIdPrefix,
        })}
        isLoading={isLoading}
        style={{
          ...style,
          ...getAIButtonIconGradientStyleVars(gradientId),
        }}
      />
    </>
  )
}

export default AIButton
